export var ConvertTaskStatus;
(function (ConvertTaskStatus) {
    ConvertTaskStatus["Waiting"] = "waiting";
    ConvertTaskStatus["Completed"] = "completed";
    ConvertTaskStatus["Failed"] = "failed";
})(ConvertTaskStatus || (ConvertTaskStatus = {}));
